import {quizQuestionComponent, QuizQuestionComponent} from "./components/question/QuizQuestionComponent";
import {Quesion, question} from "./components/question/QuestionComponent";
import {answerComponent, AnswerComponent} from "./components/answer/AnswerComponent";

export default angular.module("tfApp.components.quiz", [])
                      .component(QuizQuestionComponent, quizQuestionComponent())
                      .component(Quesion, question())
                      .component(AnswerComponent, answerComponent())
                      .name;
